import { Button, Popover, Tooltip } from 'antd';
import { useState } from 'react';
import { SupplierI, tenderDataProps } from '../../../../pages/TenderViewPage/types';
import { High, iconButton, Low, Medium, NoData, ScoreBase, ScoreBuilding, ScoreLeading, ScoreStrong } from './icons';
import './index.scss';
import { ViewSupplierDataModal } from './ViewSupplierDataModal';
import { ScoreHoverPanelContent } from './ScoreHoverPanelContent';
import { getTrustAnswerCount, MIN_TRUST_ANSWERS } from './SupplierScoreBreakdownPanel';
import done from '../../../../assets/Done, Check.svg';
import stopImage from '../../../../assets/stopImage.svg';

export const SupplierCardEvaluate1 = ({
    item,
    setIsRejectIncumbentModal,
    setSelectedSupplier,
    setIsRejectModal,
    setTaskId,
    data,
    shortlistFunc,
    isLoadingShortList,
    index,
    hideActions = false
}: {
    item: SupplierI;
    setIsRejectIncumbentModal: any;
    setSelectedSupplier: any;
    setIsRejectModal: any;
    setTaskId: any;
    data: tenderDataProps;
    shortlistFunc: any;
    isLoadingShortList: boolean;
    index: number;
    hideActions?: boolean;
}) => {
    const [isSuppModal, setIsSuppModal] = useState<boolean>(false);

    const capabilityLevelRaw = item?.score?.avg?.capability_level;
    const capabilityKey = capabilityLevelRaw?.trim().toLowerCase();
    const capabilityStatIcon =
        capabilityKey === 'basic'
            ? ScoreBase
            : capabilityKey === 'building'
            ? ScoreBuilding
            : capabilityKey === 'strong'
            ? ScoreStrong
            : capabilityKey === 'leading'
            ? ScoreLeading
            : NoData;
    const capabilityScoreNum = item?.score?.avg?.capability_score;
    const capabilityStatSpan =
        capabilityKey === 'basic' ||
        capabilityKey === 'building' ||
        capabilityKey === 'strong' ||
        capabilityKey === 'leading'
            ? capabilityLevelRaw!.trim()
            : capabilityLevelRaw?.trim() || 'No data';

    const trustLevelRaw = item?.score?.avg?.trust_level;
    const trustKey = trustLevelRaw?.trim().toLowerCase();
    const trustAnswerCountForCard = item?.score
        ? getTrustAnswerCount('gate_1', item.score.details.capability, item.score.details.trust)
        : 0;
    const showAvgTrustOnCard = trustAnswerCountForCard >= MIN_TRUST_ANSWERS;
    const trustStatIcon = !showAvgTrustOnCard
        ? NoData
        : trustKey === 'low'
        ? Low
        : trustKey === 'medium'
        ? Medium
        : trustKey === 'high'
        ? High
        : NoData;
    const trustStatLabel = !showAvgTrustOnCard
        ? 'No data'
        : trustKey === 'low' || trustKey === 'medium' || trustKey === 'high'
        ? trustLevelRaw!.trim()
        : trustLevelRaw?.trim() || 'No data';

    const file_downloaded = true;

    const rejectionReasonText =
        item.comments?.su_rejected_comment?.trim() || item.comments?.su_rejected_category_name?.trim() || '';

    return (
        <>
            <div className="supplier-card">
                <div className="supplier-card__index">{index + 1}</div>

                <div className="supplier-card__content">
                    <div className="supplier-card__header">
                        <div className="supplier-card__info">
                            <div className="supplier-card__badge-wrapper">
                                {item?.added_by_buyer && <div className="supplier-card__added">Added by buyer</div>}
                                {item.incumbent && <div className="supplier-card__badge">Incumbent Supplier</div>}
                            </div>
                            <div className="supplier-card__name">
                                <div className="title">{item.name}</div>
                                <div className="subtitle">{item?.trading_name}</div>
                            </div>
                        </div>

                        <div className="supplier-card__stats">
                            <div className="stat">
                                <div className="stat__value">
                                    {capabilityStatIcon}
                                    {capabilityScoreNum !== undefined && capabilityScoreNum !== null
                                        ? `${capabilityScoreNum}% `
                                        : ''}
                                    <span>{capabilityStatSpan}</span>
                                </div>
                                <div className="stat__label">Avg. Score</div>
                            </div>

                            <div className="divider" />

                            <div className="stat">
                                <div className="stat__value">
                                    {trustStatIcon}
                                    {trustStatLabel}
                                </div>
                                <div className="stat__label">Avg. Trust</div>
                            </div>

                            <Popover
                                trigger="click"
                                placement="topRight"
                                destroyTooltipOnHide
                                overlayClassName="supplier-card-score-popover"
                                content={<ScoreHoverPanelContent item={item} supplierListPosition={index + 1} />}
                            >
                                <div
                                    className="icon-button icon-button--popover-trigger"
                                    role="button"
                                    tabIndex={0}
                                    aria-haspopup="dialog"
                                >
                                    <div className="icon-button__icon">{iconButton}</div>
                                </div>
                            </Popover>
                        </div>
                    </div>

                    <div className="supplier-card__footer">
                        <div className="supplier-card__footer-row">
                            <Button onClick={() => setIsSuppModal(true)}>Supplier Details</Button>

                            <div className="supplier-card__actions">
                                {!hideActions && (
                                    <div className="task-complete__title-row">
                                        {item.status === 'rejected' ? (
                                            <div className="task-complete__title-row" style={{ margin: '0 12px 0 0' }}>
                                                <div className="task-complete__decline-active">
                                                    <img src={stopImage} />
                                                    Rejected
                                                </div>
                                            </div>
                                        ) : (
                                            <Tooltip
                                                title="To Reject or Shortlist the suppliers, you need download Supplier Profile Summary first!"
                                                overlayClassName={
                                                    !file_downloaded ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                                }
                                            >
                                                <div
                                                    className={`task-complete__decline ${
                                                        file_downloaded ? '' : 'disable'
                                                    }`}
                                                    onClick={() => {
                                                        if (file_downloaded) {
                                                            setTaskId(item.id);
                                                            setSelectedSupplier(item);
                                                            if (item.incumbent) {
                                                                setIsRejectIncumbentModal(true);
                                                            } else {
                                                                setIsRejectModal(true);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Reject
                                                </div>
                                            </Tooltip>
                                        )}

                                        {item.status === 'shortlisted' ? (
                                            <div className="task-complete__approved-active">
                                                <img src={done} />
                                                Shortlisted
                                            </div>
                                        ) : (
                                            <Tooltip
                                                title="To Reject or Shortlist the suppliers, you need download Supplier Profile Summary first!"
                                                overlayClassName={
                                                    !file_downloaded ? 'custom-tooltip-disabled' : 'custom-tooltip'
                                                }
                                            >
                                                <div
                                                    className={`task-complete__approved ${
                                                        !file_downloaded ? 'disabled-blue-button' : ''
                                                    }`}
                                                    onClick={() => {
                                                        if (isLoadingShortList) return;
                                                        if (file_downloaded) {
                                                            shortlistFunc(item.id);
                                                        }
                                                    }}
                                                >
                                                    Shortlist
                                                </div>
                                            </Tooltip>
                                        )}
                                    </div>
                                )}
                                {hideActions && (item.status === 'rejected' || item.status === 'shortlisted') && (
                                    <div className="task-complete__title-row">
                                        {item.status === 'rejected' && (
                                            <div className="task-complete__title-row" style={{ margin: '0 12px 0 0' }}>
                                                <div className="task-complete__decline-active">
                                                    <img src={stopImage} />
                                                    Rejected
                                                </div>
                                            </div>
                                        )}
                                        {item.status === 'shortlisted' && (
                                            <div className="task-complete__approved-active">
                                                <img src={done} />
                                                Shortlisted
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {item.status === 'rejected' && (
                            <div className="supplier-card__rejection-reason">
                                <div className="supplier-card__rejection-reason-label">Reason for Rejection</div>
                                <div className="supplier-card__rejection-reason-text">
                                    {rejectionReasonText || '—'}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {isSuppModal && (
                <ViewSupplierDataModal
                    openModal={isSuppModal}
                    setOpen={setIsSuppModal}
                    item={item}
                    supplierListPosition={index + 1}
                />
            )}
        </>
    );
};
